module.exports = __webpack_public_path__ + "img/21.21065b6f.jpg";